export default [
    {
    path: '/login',
    name: 'login',
    meta: {
      index: 2
    },
    component: () => import('@/views/login/index')
  }
  ]
  